import { z } from 'zod'

import { ProjectIdSchema } from '../unique-id.models.ts'
import { ActivityLinkTargets } from './activity-data.models.ts'
import { ActivityTypeAndDataSchema } from './utilities.ts'

export const ProjectBidAcceptedActivityDetailsSchema =
  ActivityTypeAndDataSchema(
    'project_bid_accepted',
    z.object({
      projectId: ProjectIdSchema,
      ...ActivityLinkTargets('project'),
    })
  )
